import AktosLogo from "assets/aktos-logo-1004x923.png";
import ACSLogo from "assets/acs-logo-160x36.png";
import CBYLogo from "assets/cby-logo-90x56.png";
import CSLLogo from "assets/csl-logo-160x100.png";
import CBBLogo from "assets/cbb-logo-160x91.png";
import LiveOakLogo from "assets/liveoak-logo-143x120.png";
import NCSPlusLogo from "assets/ncsplus-newlogo-160x60.png";
import SolverityLogo from "assets/solverity-logo-160x65.png";
import TSCLogo from "assets/tsc-logo-200x99-transparent.png";
import AtlasLogo from "assets/atlas-logo-294x45.png";
import CSOLogo from "assets/cso-logo-260x68.png";
import SCALogo from "assets/sca-logo-202x70.png";
import ALCSLogo from "assets/alcs-logo-293x70.png";
import BCCLogo from "assets/bcc-logo-90x65.png";
import GNWLogo from "assets/gnw-logo-200x168.png";
import CFSLogo from "assets/cfs-logo-160x46.png";
import PAMLogo from "assets/pam-logo-200x75.png";
import HUDMLogo from "assets/hudm-logo-168x69.png";

export const DEFAULT_COUNTRY = "US";

export const COUNTRIES = [
  { value: "US", label: "United States" },
  { value: "CA", label: "Canada" },
  { value: "AF", label: "Afghanistan" },
  { value: "AL", label: "Albania" },
  { value: "DZ", label: "Algeria" },
  { value: "AS", label: "American Samoa" },
  { value: "AD", label: "Andorra" },
  { value: "AO", label: "Angola" },
  { value: "AI", label: "Anguilla" },
  { value: "AQ", label: "Antarctica" },
  { value: "AG", label: "Antigua and Barbuda" },
  { value: "AR", label: "Argentina" },
  { value: "AM", label: "Armenia" },
  { value: "AW", label: "Aruba" },
  { value: "AU", label: "Australia" },
  { value: "AT", label: "Austria" },
  { value: "AZ", label: "Azerbaijan" },
  { value: "BS", label: "Bahamas" },
  { value: "BH", label: "Bahrain" },
  { value: "BD", label: "Bangladesh" },
  { value: "BB", label: "Barbados" },
  { value: "BY", label: "Belarus" },
  { value: "BE", label: "Belgium" },
  { value: "BZ", label: "Belize" },
  { value: "BJ", label: "Benin" },
  { value: "BM", label: "Bermuda" },
  { value: "BT", label: "Bhutan" },
  { value: "BO", label: "Bolivia" },
  { value: "BA", label: "Bosnia and Herzegovina" },
  { value: "BW", label: "Botswana" },
  { value: "BR", label: "Brazil" },
  { value: "BN", label: "Brunei" },
  { value: "BG", label: "Bulgaria" },
  { value: "BF", label: "Burkina Faso" },
  { value: "BI", label: "Burundi" },
  { value: "CV", label: "Cabo Verde" },
  { value: "KH", label: "Cambodia" },
  { value: "CM", label: "Cameroon" },
  { value: "KY", label: "Cayman Islands" },
  { value: "CF", label: "Central African Republic" },
  { value: "TD", label: "Chad" },
  { value: "CL", label: "Chile" },
  { value: "CN", label: "China" },
  { value: "CO", label: "Colombia" },
  { value: "KM", label: "Comoros" },
  { value: "CG", label: "Congo" },
  { value: "CD", label: "Congo (Democratic Republic)" },
  { value: "CK", label: "Cook Islands" },
  { value: "CR", label: "Costa Rica" },
  { value: "HR", label: "Croatia" },
  { value: "CU", label: "Cuba" },
  { value: "CW", label: "Curaçao" },
  { value: "CY", label: "Cyprus" },
  { value: "CZ", label: "Czech Republic" },
  { value: "CI", label: "Côte d'Ivoire" },
  { value: "DK", label: "Denmark" },
  { value: "DJ", label: "Djibouti" },
  { value: "DM", label: "Dominica" },
  { value: "DO", label: "Dominican Republic" },
  { value: "EC", label: "Ecuador" },
  { value: "EG", label: "Egypt" },
  { value: "SV", label: "El Salvador" },
  { value: "GQ", label: "Equatorial Guinea" },
  { value: "ER", label: "Eritrea" },
  { value: "EE", label: "Estonia" },
  { value: "SZ", label: "Eswatini" },
  { value: "ET", label: "Ethiopia" },
  { value: "FJ", label: "Fiji" },
  { value: "FI", label: "Finland" },
  { value: "FR", label: "France" },
  { value: "GF", label: "French Guiana" },
  { value: "PF", label: "French Polynesia" },
  { value: "GA", label: "Gabon" },
  { value: "GM", label: "Gambia" },
  { value: "GE", label: "Georgia" },
  { value: "DE", label: "Germany" },
  { value: "GH", label: "Ghana" },
  { value: "GI", label: "Gibraltar" },
  { value: "GR", label: "Greece" },
  { value: "GL", label: "Greenland" },
  { value: "GD", label: "Grenada" },
  { value: "GP", label: "Guadeloupe" },
  { value: "GU", label: "Guam" },
  { value: "GT", label: "Guatemala" },
  { value: "GG", label: "Guernsey" },
  { value: "GN", label: "Guinea" },
  { value: "GW", label: "Guinea-Bissau" },
  { value: "GY", label: "Guyana" },
  { value: "HT", label: "Haiti" },
  { value: "HN", label: "Honduras" },
  { value: "HK", label: "Hong Kong" },
  { value: "HU", label: "Hungary" },
  { value: "IS", label: "Iceland" },
  { value: "IN", label: "India" },
  { value: "ID", label: "Indonesia" },
  { value: "IR", label: "Iran" },
  { value: "IQ", label: "Iraq" },
  { value: "IE", label: "Ireland" },
  { value: "IM", label: "Isle of Man" },
  { value: "IL", label: "Israel" },
  { value: "IT", label: "Italy" },
  { value: "JM", label: "Jamaica" },
  { value: "JP", label: "Japan" },
  { value: "JE", label: "Jersey" },
  { value: "JO", label: "Jordan" },
  { value: "KZ", label: "Kazakhstan" },
  { value: "KE", label: "Kenya" },
  { value: "KI", label: "Kiribati" },
  { value: "KP", label: "North Korea" },
  { value: "KR", label: "South Korea" },
  { value: "KW", label: "Kuwait" },
  { value: "KG", label: "Kyrgyzstan" },
  { value: "LA", label: "Laos" },
  { value: "LV", label: "Latvia" },
  { value: "LB", label: "Lebanon" },
  { value: "LS", label: "Lesotho" },
  { value: "LR", label: "Liberia" },
  { value: "LY", label: "Libya" },
  { value: "LI", label: "Liechtenstein" },
  { value: "LT", label: "Lithuania" },
  { value: "LU", label: "Luxembourg" },
  { value: "MO", label: "Macao" },
  { value: "MG", label: "Madagascar" },
  { value: "MW", label: "Malawi" },
  { value: "MY", label: "Malaysia" },
  { value: "MV", label: "Maldives" },
  { value: "ML", label: "Mali" },
  { value: "MT", label: "Malta" },
  { value: "MH", label: "Marshall Islands" },
  { value: "MQ", label: "Martinique" },
  { value: "MR", label: "Mauritania" },
  { value: "MU", label: "Mauritius" },
  { value: "YT", label: "Mayotte" },
  { value: "MX", label: "Mexico" },
  { value: "FM", label: "Micronesia" },
  { value: "MD", label: "Moldova" },
  { value: "MC", label: "Monaco" },
  { value: "MN", label: "Mongolia" },
  { value: "ME", label: "Montenegro" },
  { value: "MS", label: "Montserrat" },
  { value: "MA", label: "Morocco" },
  { value: "MZ", label: "Mozambique" },
  { value: "MM", label: "Myanmar" },
  { value: "NA", label: "Namibia" },
  { value: "NR", label: "Nauru" },
  { value: "NP", label: "Nepal" },
  { value: "NL", label: "Netherlands" },
  { value: "NC", label: "New Caledonia" },
  { value: "NZ", label: "New Zealand" },
  { value: "NI", label: "Nicaragua" },
  { value: "NE", label: "Niger" },
  { value: "NG", label: "Nigeria" },
  { value: "NU", label: "Niue" },
  { value: "MK", label: "North Macedonia" },
  { value: "NO", label: "Norway" },
  { value: "OM", label: "Oman" },
  { value: "PK", label: "Pakistan" },
  { value: "PW", label: "Palau" },
  { value: "PS", label: "Palestine" },
  { value: "PA", label: "Panama" },
  { value: "PG", label: "Papua New Guinea" },
  { value: "PY", label: "Paraguay" },
  { value: "PE", label: "Peru" },
  { value: "PH", label: "Philippines" },
  { value: "PL", label: "Poland" },
  { value: "PT", label: "Portugal" },
  { value: "PR", label: "Puerto Rico" },
  { value: "QA", label: "Qatar" },
  { value: "RO", label: "Romania" },
  { value: "RU", label: "Russia" },
  { value: "RW", label: "Rwanda" },
  { value: "RE", label: "Réunion" },
  { value: "WS", label: "Samoa" },
  { value: "SM", label: "San Marino" },
  { value: "ST", label: "Sao Tome and Principe" },
  { value: "SA", label: "Saudi Arabia" },
  { value: "SN", label: "Senegal" },
  { value: "RS", label: "Serbia" },
  { value: "SC", label: "Seychelles" },
  { value: "SL", label: "Sierra Leone" },
  { value: "SG", label: "Singapore" },
  { value: "SX", label: "Sint Maarten" },
  { value: "SK", label: "Slovakia" },
  { value: "SI", label: "Slovenia" },
  { value: "SB", label: "Solomon Islands" },
  { value: "SO", label: "Somalia" },
  { value: "ZA", label: "South Africa" },
  { value: "SS", label: "South Sudan" },
  { value: "ES", label: "Spain" },
  { value: "LK", label: "Sri Lanka" },
  { value: "SD", label: "Sudan" },
  { value: "SR", label: "Suriname" },
  { value: "SE", label: "Sweden" },
  { value: "CH", label: "Switzerland" },
  { value: "SY", label: "Syria" },
  { value: "TW", label: "Taiwan" },
  { value: "TJ", label: "Tajikistan" },
  { value: "TZ", label: "Tanzania" },
  { value: "TH", label: "Thailand" },
  { value: "TL", label: "Timor-Leste" },
  { value: "TG", label: "Togo" },
  { value: "TO", label: "Tonga" },
  { value: "TT", label: "Trinidad and Tobago" },
  { value: "TN", label: "Tunisia" },
  { value: "TR", label: "Turkey" },
  { value: "TM", label: "Turkmenistan" },
  { value: "TV", label: "Tuvalu" },
  { value: "UG", label: "Uganda" },
  { value: "UA", label: "Ukraine" },
  { value: "AE", label: "United Arab Emirates" },
  { value: "GB", label: "United Kingdom" },
  { value: "UY", label: "Uruguay" },
  { value: "UZ", label: "Uzbekistan" },
  { value: "VU", label: "Vanuatu" },
  { value: "VA", label: "Vatican City" },
  { value: "VE", label: "Venezuela" },
  { value: "VN", label: "Vietnam" },
  { value: "VG", label: "Virgin Islands (British)" },
  { value: "VI", label: "Virgin Islands (U.S.)" },
  { value: "YE", label: "Yemen" },
  { value: "ZM", label: "Zambia" },
  { value: "ZW", label: "Zimbabwe" },
];

export const DATE_FORMAT = "MM/DD/YYYY";
export const TIME_FORMAT = "hh:mm A z";
export const DATE_TIME_FORMAT = "MM/DD/YYYY hh:mm A z";

// Debtor search constants
export const DEBTOR_SEARCH_DEBOUNCE_MS = 500;
export const DEBTOR_SEARCH_MIN_CHARS = 3;

// Maximum number of accounts/debtors allowed per bulk action
export const BULK_ACTION_MAX_RECORDS = 50000;

export const PROCESSED_PAYMENT_METHODS = ["process_card", "process_ach"];

// All payments made toe the Creditor are explicitly logged as a 'Paid to Creditor'
// payment method.
export const PAID_TO_CREDITOR_PAYMENT_METHOD_OPTIONS = [
  { value: "paid_to_creditor", label: "Paid to Creditor" },
  { value: "paid_to_creditor_legal", label: "Paid to Creditor (Legal Payment)" },
];

export const CREDITOR_PORTAL_PAYMENT_METHOD_OPTIONS = [
  { value: "paid_to_creditor", label: "Paid to Creditor" },
];

// All payments made to a Forwarding Entity are explicitly logged as a 'Forwarding Entity'
// payment method.
export const PAID_TO_FORWARDING_ENTITY_PAYMENT_METHOD_OPTIONS = [
  { value: "forwarding_entity", label: "Forwarding Entity" },
  { value: "forwarding_entity_legal", label: "Forwarding Entity (Legal Payment)" },
];

// Payment Plans can be set up for payments to be processed in the future. Doesn't make sense
// to have payment methods that are only for logging (cash, check, online portal).
export const PROCESS_PAYMENT_METHOD_OPTIONS = [
  { value: "process_card", label: "Card" },
  { value: "process_ach", label: "ACH" },
];

export const PAID_TO_AGENCY_LOGGED_PAYMENT_METHOD_OPTIONS = [
  { value: "ach", label: "ACH" },
  { value: "balance_transfer", label: "Balance Transfer" },
  { value: "card", label: "Card" },
  { value: "cash", label: "Cash" },
  { value: "check", label: "Check" },
  { value: "online_portal", label: "Online Portal" },
  { value: "bankruptcy", label: "Bankruptcy Payment" },
  { value: "legal", label: "Legal" },
  { value: "promise_to_pay", label: "Promise to Pay" },
  { value: "other", label: "Other" },
];

export const LEGACY_PAYMENT_METHOD_OPTIONS = [{ value: "legacy", label: "Legacy" }];

export const PAYMENT_METHOD_OPTIONS = [
  {
    label: "Process options",
    options: PROCESS_PAYMENT_METHOD_OPTIONS,
  },
  {
    label: "Logging options",
    options: PAID_TO_AGENCY_LOGGED_PAYMENT_METHOD_OPTIONS,
  },
];

export const ALL_PAYMENT_METHOD_VALUES = PAID_TO_AGENCY_LOGGED_PAYMENT_METHOD_OPTIONS.concat(
  PAID_TO_CREDITOR_PAYMENT_METHOD_OPTIONS,
)
  .concat(PAID_TO_FORWARDING_ENTITY_PAYMENT_METHOD_OPTIONS)
  .concat(PROCESS_PAYMENT_METHOD_OPTIONS)
  .concat(LEGACY_PAYMENT_METHOD_OPTIONS)
  .map((option) => option.value);

export const PAYMENT_INTENT_STATUS = {
  NEW: "new",
  EXECUTED: "executed",
  REFUNDED: "refunded",
  VOIDED: "voided",
  EXECUTE_ERROR: "execute_error",
  REFUND_ERROR: "refund_error",
  VOID_ERROR: "void_error",
};

export const PAYMENT_INTENT_ERROR_STATUS_TO_TEXT = {
  execute_error: "Execute Error",
  refund_error: "Refund Error",
  void_error: "Void Error",
};

export const PAYMENT_TRANSACTION_STATUS = {
  SUCCESS: "success",
  DECLINED: "declined",
  ERROR: "error",
};

export const CREDITOR_DOCUMENT_TYPE_OPTIONS = [
  { value: "new_account_placement", label: "New Account Placement" },
  { value: "credit_report", label: "Credit Report" },
  { value: "creditor_communication", label: "Creditor Communication" },
  { value: "invoice", label: "Invoice" },
  { value: "invoice_check", label: "Invoice Check" },
];

export const CREDITOR_DOCUMENT_TYPE_OPTIONS_FOR_CREDITOR_PORTAL = [
  { value: "new_account_placement", label: "New Account Placement" },
  { value: "invoice", label: "Invoice" },
  { value: "invoice_check", label: "Invoice Check" },
  { value: "other", label: "Other" },
];

export const ORGANIZATION_STATUS = {
  active: "active",
  inactive: "inactive",
  prospect: "prospect",
};

export const COMMUNICATION_TASK_STATUS = {
  SCHEDULED: "scheduled",
  SUCCESS: "success",
  FAILED: "failed",
};

export const DEFAULT_LOGIN_REDIRECT_SCREEN_OPTIONS = [
  { value: "", label: "None" },
  { value: "accounts", label: "Accounts" },
  { value: "creditors", label: "Client Worklist" },
];

// This is the default route if a user does not have a defaultLoginRedirectScreen
export const DEFAULT_LOGIN_REDIRECT_SCREEN = "accounts";

// This is settings for whitelabeling solution
// any new subdomains custom settings for an agency will require a new object here to configure
// https://picresize.com/ to resize logos
export const WHITELABEL_SETTINGS = [
  {
    logo: AktosLogo,
    slug: "test",
    website: "https://www.google.com",
    displayName: "test",
    address: "123 Main St Anytown, USA 12345",
    phone: "(123)-456-7890",
    email: "testagency@gmail.com",
  },
  {
    logo: ACSLogo,
    slug: "acs",
    website: "https://www.acscollections.com/",
    displayName: "American Collection Systems",
    address: "202 W Johnstown Rd., Gahanna, OH 43230",
    phone: "(800)-561-9118",
    email: "customerservice@acscollections.com",
  },
  {
    logo: CBBLogo,
    slug: "cbb",
    website: "https://www.centralbusinessbureau.com/",
    displayName: "Central Business Bureau Inc",
    address: "252 North Hockett St. Porterville, CA 93257",
    phone: "(559)-784-4093",
    email: "info@centralbusinessbureau.com",
  },
  {
    logo: CBYLogo,
    slug: "cby",
    website: "https://cby.com/",
    displayName: "CBY",
    address: "334 Carlisle Ave. York PA 17404",
    phone: "(800)-717-4229",
    email: "info@cby.com",
  },
  {
    logo: CSLLogo,
    slug: "csl",
    website: "https://www.csl.com",
    displayName: "CSL",
    address: "123 Main St Anytown, USA 12345",
    phone: "(123)-456-7890",
    email: "csl@gmail.com",
  },
  {
    logo: NCSPlusLogo,
    slug: "ncs",
    website: "https://www.ncs.com",
    displayName: "NCSPlus",
    address: "123 Main St Anytown, USA 12345",
    phone: "(123)-456-7890",
    email: "ncs@gmail.com",
    signupProps: {
      preTransform: (values) => {
        return {
          ...values,
          // creditorCode could be AAAAAA, AAAAAA01, AAAAAA02, etc. We only want the first 6 characters.
          creditorCode: values.creditorCode.substring(0, 6),
        };
      },
    },
  },
  {
    logo: LiveOakLogo,
    slug: "liveoak",
    website: "https://www.liveoak.com",
    displayName: "Live Oak",
    address: "123 Main St Anytown, USA 12345",
    phone: "(123)-456-7890",
    email: "liveoak@gmail.com",
  },
  {
    logo: SolverityLogo,
    slug: "solv",
    website: "https://www.solveritynw.com/",
    displayName: "Solverity",
    address: "9707 NE 54th Street, Suite A, Vancouver, WA 98662",
    phone: "(360)-604-8514",
    email: "help@solveritynw.com",
  },
  {
    logo: TSCLogo,
    slug: "tsc",
    website: "https://www.tscarsolutions.com",
    displayName: "TSC",
    address: "3900 South Stonebridge Dr., Suite 701, McKinney, TX 75070",
    phone: "(760)-444-5750",
    email: "support@tscarsolutions.com",
  },
  {
    logo: AtlasLogo,
    slug: "aci",
    website: "https://www.atlascollections.com",
    displayName: "ACI",
    address: "1410 Broad St. New Castle, IN 47362​",
    phone: "(765)-529-3377",
    email: "contactus@atlascollects.com",
  },
  {
    logo: CSOLogo,
    slug: "cso",
    website: "https://creditservicescso.com",
    displayName: "CSO",
    address: "1229 SE Stephens Roseburg, OR 97470",
    phone: "(800)-888-6597",
    email: "noreply@creditservicescso.com",
  },
  {
    logo: SCALogo,
    slug: "sca",
    website: "https://southerncreditadj.com",
    displayName: "SCA",
    address: "2420 Professional Drive, Suite A Rocky Mount, NC 27804",
    phone: "1-800-682-9685",
    email: "customerservice@southerncreditadj.com",
  },
  {
    logo: ALCSLogo,
    slug: "alcs",
    website: "https://alcs.portal.getaktos.com",
    displayName: "Allied Collection Services, Inc.",
    address: "1607 Central Ave, Columbus, IN 47201, USA",
    phone: "(800) 310-3349",
    email: "collections@alliedcollectionservice.com",
  },
  {
    logo: BCCLogo,
    slug: "bcc",
    website: "https://bcc.portal.getaktos.com",
    displayName: "Butte Credit",
    address: "60 Declaration Dr a, Chico, CA 95973",
    phone: "(530) 342-0133",
    email: "info@buttecredit.com",
  },
  {
    logo: HUDMLogo,
    slug: "hudm",
    website: "https://hudm.portal.getaktos.com",
    displayName: "Hudson Management",
    address: "42 Four Season Center Suite 132C, Chesterfield, MO 63017",
    phone: "(205) 313-2569",
    email: "jedwards@hudsonmanagementservices.net",
  },
  {
    logo: GNWLogo,
    slug: "gnw",
    website: "https://grantweber.com",
    displayName: "Grant & Weber",
    address: "5586 S. Fort Apache Rd. Suite 110 Las Vegas, NV 89148",
    phone: "(800) 947-1656",
  },
  {
    logo: CFSLogo,
    slug: "cfs",
    website: "https://chapmanfs.com",
    displayName: "Chapman Financial Services",
    address: "P.O. Box 7100, Coeur d'Alene, ID 83816",
    phone: "(800) 594-9866",
    email: "idahocollector@chapmanfs.com",
  },
  {
    logo: PAMLogo,
    slug: "pam",
    website: "https://www.profactmgt.com",
    displayName: "Professional Account Management",
    address: "318 N. 4th Street, Coeur d'Alene, ID 83814",
    phone: "(800) 873-6071",
    email: "info@profactmgt.com",
  },
];
